<template>
  <div class="account-root">
    <CCard>
      <CCardHeader>
        <span class="account-section-title text-info">Información General</span>
        <br />
        <br />
        <span v-if="(type == 'supplier' || type == 'manager' || type == 'executive') && owner !== null" class="account-indented"><b>Ruta: </b>{{ owner.code }}</span>
        <br />
        <span class="account-indented"><b>Nombre: </b>{{ user.last_name }}</span>
      </CCardHeader>
      <CCardBody>
        <CButton color="default" size="sm" @click="$emit('edit-user')" class="float-right"><CIcon name="cil-pencil"/></CButton>
        <span class="account-section-title text-info">Información de Acceso</span>
        <br /><br />
        <span class="account-indented"><b>Correo: </b>{{ user.email }}</span>
        <br />
        <span class="account-indented"><b>Contraseña: </b>********</span>
      </CCardBody>
      <CCardFooter>
        <CButton color="default" size="sm" @click="$emit('edit-contact')" class="float-right"><CIcon name="cil-pencil"/></CButton>
        <span class="account-section-title text-info">Información de Contacto</span>
        <br /><br />
        <div class="account-indented account-address">{{ user.address }}{{ user.colony ? ', ' + user.colony : '' }}{{ user.city ? ', ' + user.city : '' }}{{ user.state ? ', ' + user.state : '' }}. {{ user.zipcode ? 'C.P. ' + user.zipcode + '.' : '' }}</div>
        <br v-if="user.whatsapp" /><span class="account-indented" v-if="user.whatsapp"><b>Whatsapp: </b>{{ user.whatsapp }}</span>
      </CCardFooter>
      <CCardFooter v-if="owner && owner.wallet">
        <span class="account-section-title text-info">Monedero Electronico</span>
        <br /><br />
        <div class="account-indented account-address"><b>{{ owner.wallet }}</b></div>
        <CButton @click="$emit('confirm-wallet')" v-show="owner.wallet !== '' && owner.confirm_wallet !== 1" color="success" size="sm" class="m-1 account-confirm-button">Confirmar</CButton>
      </CCardFooter>
    </CCard>
  </div>
</template>

<script>
export default {
  name: 'SupplierAccountCard',
  props: {
    user: {
      type: Object,
      default: () => ({})
    },
    owner: {
      type: Object,
      default: null
    },
    type: {
      type: String,
      default: 'supplier'
    }
  }
}
</script>

<style scoped>
.account-root {
  font-size: 12px;
}

.account-section-title {
  font-weight: bold;
}

.account-indented {
  padding-left: 15px;
}

.account-address {
  width: 250px;
}

.account-confirm-button {
  font-size: 12px;
}
</style>
